import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { Contact } from '@/screens/Contact';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function ContactPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Freight logistics, freight technology, carrier operations, load board, freight factoring, fuel card, trucker fuel card, freight tms, truck management software, truck management system, freight dispatch, freight dispatching software, ELD integrations, fleet management software, fleet management services, trucking back office services, truck tracking service, freight performance reporting, trucking drive safety, carrier setup, carrier website"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title="Contact Us | Loadsmart"
        description="Contact a member of the Loadsmart team and get access to our network of logistics experts."
        canonical="https://loadsmart.com/contact/"
        openGraph={{
          url: 'https://loadsmart.com/contact/',
        }}
      />
      <JsonLd data={Organization} />
      <Contact />
    </>
  );
}
